// D:\Event\frontend\src\App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Sidebar from "./Sidebar";
import Register from "./components/register";
import Welcome from "./components/Welcome";
import Login from "./components/Login";
import FirstVideo  from "./components/FirstVideo";

import Award from "./components/Award";
import Endpage from "./components/Endpage";
import FirstPage from "./components/firstpage";
import IDCard from "./components/id_card";   // <-- NEW IMPORT
import Coupon from "./components/Coupon";   // <-- NEW IMPORT
import Invition from "./components/Invition";   // <-- NEW IMPORT
import Point from "./components/Point";   // <-- NEW IMPORT
import Qr from "./components/Qr";   // <-- NEW IMPORT
import Profile from "./components/Profile";   // <-- NEW IMPORT






export default function App() {
  return (
    <BrowserRouter>
      <Sidebar /> {/* <-- Sidebar always visible */}

      <Routes>
        
        <Route path="/" element={<FirstVideo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/firstpage" element={<FirstPage />} /> 
        <Route path="/register" element={<Register />} />
        <Route path="/award" element={<Award />} />
        <Route path="/endpage" element={<Endpage />} />

        <Route path="/idcard" element={<IDCard />} /> {/* <-- NEW PAGE */}
        <Route path="/coupon" element={<Coupon />} />
        <Route path="/Invition" element={<Invition />} />
        <Route path="/point" element={<Point />} />
        <Route path="/qrcode" element={<Qr />} />
        <Route path="/Profile" element={<Profile />} />






      </Routes>
    </BrowserRouter>
  );
}
